import React from 'react';
import { Text } from 'react-native';
export default class TipTitle extends React.PureComponent {
    render() {
        let text = this.props.text;
        let customStyle = this.props.customStyle;
        return <Text style={[{ color: customStyle === null || customStyle === void 0 ? void 0 : customStyle.brandColor }]}>{text}</Text>;
    }
}
